
/**
 * List of all english error messages by error code 
 */
const _messagesEN = {
    [999]: "Unexpected error"
};

type ErrorMessageRecord = typeof _messagesEN;

/**
 * List of all french error messages by error code 
 */
const _messagesFR: ErrorMessageRecord = {
    [999]: "Erreur inattendue"
};

/**
 * Default error messages per language and per code (messages["fr"][999])
 */
export const ERROR_MESSAGES = {
    "en": _messagesEN,
    "fr": _messagesFR
};